"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScaleContext = useScaleContext;
exports["default"] = exports.ScaleContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

var _Colors = _interopRequireDefault(require("./Colors"));

var _Ticks = _interopRequireDefault(require("./Ticks"));

var _Marker = _interopRequireDefault(require("./Marker"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ScaleContext = /*#__PURE__*/_react["default"].createContext();

exports.ScaleContext = ScaleContext;

function useScaleContext() {
  var context = _react["default"].useContext(ScaleContext);

  if (!context) {
    throw new Error("Scale compound components cannot be rendered outside the Scale component");
  }

  return context;
}
/**
 * Scales are compound components that can consist of one or more of the following children:
 *
 * - `<Scale.Colors />`: renders the scale's colors
 * - `<Scale.Ticks />`: renders an axis to label the scale
 * - `<Scale.Marker />` renders a marker on the scale at a given value
 *
 * ## Example
 *
 * ```jsx
 * <Scale
 *   data=[1, 10, 500, 100]
 *   type="continuous"
 *   width={250}
 *   colors="YlGnBu"
 *   margin={{top: 0, bottom: 0, left: 24, right: 24}}
 * >
 *   <Scale.Marker value={612} label="612" />
 *   <Scale.Colors height={24} />
 *   <Scale.Ticks height={24}  />
 * </Scale>
 * ```
 *
 * See the README.md for more detailed usage.
 */


var Scale = function Scale(_ref) {
  var data = _ref.data,
      colors = _ref.colors,
      accessor = _ref.accessor,
      nice = _ref.nice,
      thresholds = _ref.thresholds,
      amount = _ref.amount,
      width = _ref.width,
      type = _ref.type,
      margin = _ref.margin,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["data", "colors", "accessor", "nice", "thresholds", "amount", "width", "type", "margin", "children", "className"]);

  var options = (0, _react.useMemo)(function () {
    return {
      accessor: accessor,
      thresholds: thresholds,
      amount: amount,
      nice: nice
    };
  }, [accessor, thresholds, amount, nice]);
  var value = (0, _react.useMemo)(function () {
    var scales = (0, _utils.getScales)(type, data, colors, options);
    return _objectSpread({
      width: width,
      type: type,
      margin: margin,
      colors: colors,
      data: data,
      thresholds: thresholds
    }, scales);
  }, [width, colors, thresholds, type, margin, data, options]);
  return /*#__PURE__*/_react["default"].createElement(ScaleContext.Provider, {
    value: value
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, _extends({
    position: "relative",
    display: "inline-block",
    className: (0, _clsx["default"])("HypScale-root", className)
  }, props), children));
};

Scale.propTypes = {
  /** type of scale to use */
  type: _propTypes["default"].oneOf(["category", "continuous", "quantize", "quantile", "threshold"]),

  /** width of the scale */
  width: _propTypes["default"].number,

  /** either an array of colors or a string representing a scale from [d3-scale-chromatic](https://observablehq.com/@d3/color-schemes?collection=@d3/d3-scale-chromatic) */
  colors: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),

  /** an object containing top, left, bottom, right margins for the scale */
  margin: _propTypes["default"].object,

  /** adjusts the scale to use "nice" values (e.g. 1000 instead of 994) */
  nice: _propTypes["default"].bool,

  /** A set of data values to use for the scale */
  data: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].object])),

  /** A function that selects a data value (used when `data` is an array of objects instead of an array of values) */
  accessor: _propTypes["default"].func,

  /** Contains threshold points when using `threshold` type */
  thresholds: _propTypes["default"].arrayOf(_propTypes["default"].number),

  /** Determines how many groups to split data into for `quantize` and `quantile` scales. */
  amount: _propTypes["default"].number
};
Scale.Colors = _Colors["default"];
Scale.Ticks = _Ticks["default"];
Scale.Marker = _Marker["default"];
Scale.__docgenInfo = {
  "description": "Scales are compound components that can consist of one or more of the following children:\n\n- `<Scale.Colors />`: renders the scale's colors\n- `<Scale.Ticks />`: renders an axis to label the scale\n- `<Scale.Marker />` renders a marker on the scale at a given value\n\n## Example\n\n```jsx\n<Scale\n  data=[1, 10, 500, 100]\n  type=\"continuous\"\n  width={250}\n  colors=\"YlGnBu\"\n  margin={{top: 0, bottom: 0, left: 24, right: 24}}\n>\n  <Scale.Marker value={612} label=\"612\" />\n  <Scale.Colors height={24} />\n  <Scale.Ticks height={24}  />\n</Scale>\n```\n\nSee the README.md for more detailed usage.",
  "methods": [],
  "displayName": "Scale",
  "props": {
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"category\"",
          "computed": false
        }, {
          "value": "\"continuous\"",
          "computed": false
        }, {
          "value": "\"quantize\"",
          "computed": false
        }, {
          "value": "\"quantile\"",
          "computed": false
        }, {
          "value": "\"threshold\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "type of scale to use"
    },
    "width": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "width of the scale"
    },
    "colors": {
      "type": {
        "name": "union",
        "value": [{
          "name": "array"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "either an array of colors or a string representing a scale from [d3-scale-chromatic](https://observablehq.com/@d3/color-schemes?collection=@d3/d3-scale-chromatic)"
    },
    "margin": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "an object containing top, left, bottom, right margins for the scale"
    },
    "nice": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "adjusts the scale to use \"nice\" values (e.g. 1000 instead of 994)"
    },
    "data": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "number"
          }, {
            "name": "object"
          }]
        }
      },
      "required": false,
      "description": "A set of data values to use for the scale"
    },
    "accessor": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A function that selects a data value (used when `data` is an array of objects instead of an array of values)"
    },
    "thresholds": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "number"
        }
      },
      "required": false,
      "description": "Contains threshold points when using `threshold` type"
    },
    "amount": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Determines how many groups to split data into for `quantize` and `quantile` scales."
    }
  }
};
var _default = Scale;
exports["default"] = _default;